import {Injectable} from '@angular/core';
import {YtbesprechungService} from '../../../generated-api';
import {catchError, shareReplay, tap} from 'rxjs/operators';
import {of} from 'rxjs';
import {YtbesprechungStoreService} from './ytbesprechung-store.service';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class YtbesprechungPageService {

  constructor(private ytbesprechungService: YtbesprechungService,
              private store: YtbesprechungStoreService,
              private translateService: TranslateService) {
  }

  getYtBesprechung(id: number): any {
    this.store.loading = true;
    return this.ytbesprechungService.getYTBesprechung(id, 'body', false).pipe(shareReplay(1), catchError(err => {
      this.store.loading = false;
      this.store.searchError = this.translateService.instant('error.internal');
      this.store.selectedYTBesprechung = null;
      return of(null);
    }), tap(val => {
      if (val) {
        this.store.selectedYTBesprechung = val;
        this.store.loading = false;
        this.store.searchError = null;
      }
    }));
  }
}
